




















import { Component, Vue } from "vue-property-decorator";
import App from "./App.vue";

@Component({
  components: {
    App,
  },
})
export default class LockApp extends Vue {
  PASSWORD = "MYtownkl@2022";
  TIME_LIMIT = 180;
  isAppLocked = true;

  beforeMount() {
    // Set an event to set current time when browser closes
    const LockAppComponent = this;
    window.onbeforeunload = function () {
      const currentTime = localStorage.getItem("currentTime");
      if (currentTime) {
        LockAppComponent.setCurrentTime();
      }
    };

    // Checks whether currentTime exceeds the TIME_LIMIT
    const currentTime = localStorage.getItem("currentTime");
    if (currentTime) {
      const now = new Date().getTime();
      const timeElapsed = now - parseInt(currentTime);

      if (timeElapsed / 60000 > this.TIME_LIMIT) {
        localStorage.removeItem("currentTime");
        this.isAppLocked = true;
      } else {
        this.isAppLocked = false;
      }
    }
  }

  created() {}

  checkPassword() {
    if ((this.$refs.input as HTMLInputElement).value === this.PASSWORD) {
      this.setCurrentTime();
      this.isAppLocked = false;
    }
  }

  setCurrentTime() {
    const now = new Date().getTime();
    localStorage.setItem("currentTime", now.toString());
  }
}
